import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export function ReturnModal({ isOpen, onClose, onConfirm, invoiceId }) {
  const [returnDate, setReturnDate] = useState("");
  const [returnReason, setReturnReason] = useState("");

  const handleConfirm = () => {
    if (!returnDate || !returnReason) {
      return;
    }
    onConfirm(returnDate, returnReason);
    setReturnDate("");
    setReturnReason("");
  };

  const handleClose = () => {
    setReturnDate("");
    setReturnReason("");
    onClose();
  };

  return (
    <Dialog open={isOpen} onOpenChange={handleClose}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle>İade Detaylarını Girin</DialogTitle>
          <DialogDescription>
            Lütfen şu numaralı fatura için iade tarihi ve sebebini girin: #{invoiceId}
          </DialogDescription>
        </DialogHeader>
        <div className="grid gap-4 py-4">
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="returnDate" className="text-right">
              İade Tarihi
            </Label>
            <Input
              id="returnDate"
              type="date"
              className="col-span-3 dark:[color-scheme:dark]"
              value={returnDate}
              onChange={(e) => setReturnDate(e.target.value)}
            />
          </div>
          <div className="grid grid-cols-4 items-center gap-4">
            <Label htmlFor="returnReason" className="text-right">
              İade Sebebi
            </Label>
            <Textarea
              id="returnReason"
              className="col-span-3"
              placeholder="İade sebebini girin..."
              value={returnReason}
              onChange={(e) => setReturnReason(e.target.value)}
            />
          </div>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={handleClose}>
            İptal
          </Button>
          <Button onClick={handleConfirm} disabled={!returnDate || !returnReason}>
            Onayla
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
